/*
  Quick order (spec 6.7), loaded only by the hx-quick-order section. Uses the helpers
  hatch.js exposes on window.Hatch, so it must load after hatch.js (both are deferred).
*/
(() => {
  'use strict';

  const { root, money, escapeHtml, syncQty, selectTab, track, addToCart } = window.Hatch;

  const qoLookup = (sku) => fetch(`${root()}search?q=${encodeURIComponent(sku)}&type=product&view=hx-sku`)
    .then((r) => r.json())
    .catch(() => ({ exact: [], suggestions: [] }));

  const qoTotals = (qo) => {
    let count = 0;
    let cents = 0;
    qo.querySelectorAll('[data-hx-qo-line]').forEach((line) => {
      if (!line.dataset.variant) return;
      const qty = Number(line.querySelector('input[type="number"]').value) || 0;
      count += qty;
      cents += qty * Number(line.dataset.price || 0);
    });
    const sum = qo.querySelector('[data-hx-qo-sum]');
    sum.textContent = count ? qo.dataset.labelItems.replace('[count]', count).replace('[total]', money(cents / 100)) : '';
    qo.querySelector('[data-hx-qo-submit]').disabled = count === 0;
  };

  const qoResolve = (line) => {
    const qo = line.closest('[data-hx-quickorder]');
    const sku = line.querySelector('[data-hx-qo-sku]').value.trim();
    const name = line.querySelector('[data-hx-qo-name]');
    const price = line.querySelector('[data-hx-qo-price]');
    const error = line.querySelector('[data-hx-qo-lineerror]');
    delete line.dataset.variant;
    error.hidden = true;
    if (!sku) { name.textContent = ''; price.textContent = ''; qoTotals(qo); return Promise.resolve(); }
    name.textContent = '…';
    return qoLookup(sku).then((data) => {
      const match = data.exact && data.exact[0];
      if (!match) {
        name.textContent = '';
        price.textContent = '';
        error.textContent = qo.dataset.labelNotfound;
        error.hidden = false;
      } else {
        line.dataset.variant = match.id;
        line.dataset.price = match.price;
        name.textContent = match.variant && match.variant !== 'Default Title' ? `${match.title}, ${match.variant}` : match.title;
        price.textContent = money(match.price / 100);
        if (!match.available) { error.textContent = qo.dataset.labelUnavailable; error.hidden = false; }
      }
      qoTotals(qo);
    });
  };

  let qoCounter = 0;
  const qoAddLine = (qo, sku = '', qty = 1) => {
    qoCounter += 1;
    const id = `qo-${qoCounter}`;
    const li = document.createElement('li');
    li.className = 'hx-qo__line';
    li.dataset.hxQoLine = '';
    li.innerHTML = `
      <label class="hx-vh" for="${id}-sku">${escapeHtml(qo.dataset.labelSku)}</label>
      <input class="hx-qo__sku hx-mono" id="${id}-sku" type="text" autocomplete="off" spellcheck="false" placeholder="${escapeHtml(qo.dataset.labelPlaceholder)}" data-hx-qo-sku value="${escapeHtml(sku)}">
      <span class="hx-qo__name" data-hx-qo-name></span>
      <span class="hx-qo__price hx-display" data-hx-qo-price></span>
      <div class="hx-qty" data-hx-qty>
        <button type="button" class="hx-qty__btn" data-hx-step="-1" aria-label="-">&minus;</button>
        <input class="hx-qty__input" type="number" min="1" value="${Number(qty) || 1}" inputmode="numeric" aria-label="${escapeHtml(qo.dataset.labelQty)}">
        <button type="button" class="hx-qty__btn" data-hx-step="1" aria-label="+">+</button>
      </div>
      <button type="button" class="hx-iconbtn hx-qo__remove" data-hx-qo-remove aria-label="${escapeHtml(qo.dataset.labelRemove)}"><svg class="hx-icon" width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
      <p class="hx-pcard__error hx-qo__lineerror" role="alert" data-hx-qo-lineerror hidden></p>`;
    qo.querySelector('[data-hx-qo-lines]').appendChild(li);
    syncQty(li.querySelector('[data-hx-qty]'));
    return li;
  };

  const qoParse = (qo, text) => {
    const rows = text.split(/\r?\n/).map((row) => row.split(/[,\t;]/).map((cell) => cell.replace(/^"|"$/g, '').trim()))
      .filter((cells) => cells[0] && !/^sku$/i.test(cells[0]));
    const lines = qo.querySelector('[data-hx-qo-lines]');
    lines.querySelectorAll('[data-hx-qo-line]').forEach((line) => { if (!line.querySelector('[data-hx-qo-sku]').value.trim()) line.remove(); });
    const added = rows.map(([sku, qty]) => qoAddLine(qo, sku, qty || 1));
    qoAddLine(qo);
    const tab = qo.querySelector('[role="tab"]');
    if (tab) selectTab(tab, false);
    return Promise.all(added.map(qoResolve));
  };

  const initQuickOrder = (scope) => {
    scope.querySelectorAll('[data-hx-quickorder]').forEach((qo) => {
      if (qo.dataset.hxReady) return;
      qo.dataset.hxReady = '1';
      for (let i = 0; i < 3; i += 1) qoAddLine(qo);
    });
  };

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (t.matches('[data-hx-qo-sku]')) qoResolve(t.closest('[data-hx-qo-line]'));
    else if (t.closest('[data-hx-qo-line]')) qoTotals(t.closest('[data-hx-quickorder]'));
    else if (t.matches('[data-hx-qo-csv]') && t.files && t.files[0]) {
      t.files[0].text().then((text) => qoParse(t.closest('[data-hx-quickorder]'), text));
    }
  });

  document.addEventListener('keydown', (event) => {
    const t = event.target;
    if (event.key === 'Enter' && t instanceof HTMLInputElement && t.matches('[data-hx-qo-sku]')) {
      event.preventDefault();
      t.blur();
    }
  });

  document.addEventListener('click', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    const qo = t && t.closest('[data-hx-quickorder]');
    if (!qo) return;
    if (t.closest('[data-hx-qo-addline]')) { qoAddLine(qo).querySelector('[data-hx-qo-sku]').focus(); return; }
    const remove = t.closest('[data-hx-qo-remove]');
    if (remove) { remove.closest('[data-hx-qo-line]').remove(); qoTotals(qo); return; }
    if (t.closest('[data-hx-qo-parse]')) { qoParse(qo, qo.querySelector('[data-hx-qo-paste]').value); return; }
    const submit = t.closest('[data-hx-qo-submit]');
    if (!submit) return;
    const lines = Array.from(qo.querySelectorAll('[data-hx-qo-line]')).filter((line) => line.dataset.variant);
    const items = lines.map((line) => ({ id: Number(line.dataset.variant), quantity: Number(line.querySelector('input[type="number"]').value) || 1 }));
    const error = qo.querySelector('[data-hx-qo-error]');
    submit.disabled = true;
    error.hidden = true;
    track('quick_order_submitted', { lines: items.length });
    addToCart(items).then((result) => {
      if (!result.error) { error.textContent = qo.dataset.labelAdded; error.hidden = false; return null; }
      // One line failed: add line by line so each failure is shown where it happened
      return lines.reduce((chain, line, i) => chain.then(() => addToCart([items[i]]).then((r) => {
        const lineError = line.querySelector('[data-hx-qo-lineerror]');
        if (r.error) { lineError.textContent = r.error; lineError.hidden = false; }
      })), Promise.resolve());
    }).finally(() => { submit.disabled = false; });
  });

  initQuickOrder(document);
  document.addEventListener('shopify:section:load', (event) => initQuickOrder(event.target));
})();
